<h3 mat-dialog-title >
    <b>Custo</b> 
</h3>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Descrição</mat-label>
        <input 
            matInput 
            placeholder="Descrição"
            aria-label="Descrição" 
            [formControl]="descricao" 
            required
            maxlength="255">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Beneficiário/Credor</mat-label>
        <input 
            matInput 
            placeholder="Beneficiário/Credor"
            aria-label="Beneficiário/Credor" 
            [formControl]="beneficiario" 
            required
            maxlength="255">
    </mat-form-field>
</div>
<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Valor</mat-label>
        <input matInput placeholder="Valor" [formControl]="valor"
            name="valor" maxlength="255" currencyMask
            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
    </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
     <mat-form-field appearance="outline" floatLabel="always" style="width: 100%" fxFlex="100">
        <mat-label>Tipo de Custo</mat-label>
        <mat-select
             [(value)]="model.tipo_custo_id"
             [formControl]="tipo_custo_id">
             <mat-option value="">SELECIONE</mat-option>
             <mat-option *ngFor="let tipoCusto of listaTipoCusto"
                 [value]="tipoCusto.id">{{tipoCusto.descricao}}</mat-option>
        </mat-select>
        <mat-spinner diameter="20" *ngIf="loadingSpinnerTipoCusto"></mat-spinner> 
     </mat-form-field>
 </div>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="!isSelectRecorrenteMensal()">
    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
        <mat-label>Prazo em Mêses</mat-label>
        <input 
            matInput 
            placeholder="Prazo em Mêses"
            aria-label="Prazo em Mêses" 
            [formControl]="qtd_meses" 
            required
            maxlength="3"
            type="number">
    </mat-form-field>
</div>

 <div mat-dialog-actions style="text-align: center; margin-top: 20px;">
     <button 
         mat-button 
         tabindex="2" 
         (click)="onNoClick()">
         Cancelar
     </button>
     <button 
         mat-button 
         [disabled]="isInvalidForm()" 
         (click)="salvar()" 
         tabindex="-1">
         Confirmar
     </button>
 </div>